import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  modalContent: theme => css`
    padding: ${theme.spacing.sm} ${theme.spacing.xxs};
  `,
})

export default useStyles
